import { render, staticRenderFns } from "./gerenshiming.vue?vue&type=template&id=337efd50&scoped=true"
import script from "./gerenshiming.vue?vue&type=script&lang=js"
export * from "./gerenshiming.vue?vue&type=script&lang=js"
import style0 from "./gerenshiming.vue?vue&type=style&index=0&id=337efd50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337efd50",
  null
  
)

export default component.exports